import { isExecutorStopSignalled } from './executor-stop-signal';
import { useExecutorSnapshot } from './useExecutorSnapshot';

// App-wide: every surface reads the same executor slot, whichever webview cancelled.
export const useExecutorStopSignal = (childRunId: string | undefined): boolean =>
  isExecutorStopSignalled(useExecutorSnapshot(), childRunId);
